import { makeStyles } from '@material-ui/core';
import mark from './assets/aeven-oneplatform-mark.png';
import { LOGO_CREAM, LOGO_PADDING } from './brand';

const SIZE = 40;
const PAD = Math.round(SIZE * LOGO_PADDING);
const ART = SIZE - 2 * PAD;

const useStyles = makeStyles(theme => ({
  plate: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: SIZE,
    height: SIZE,
    boxSizing: 'border-box',
    borderRadius: theme.shape.borderRadius,
    background: LOGO_CREAM,
  },
  mark: {
    width: ART,
    height: ART,
    display: 'block',
  },
}));

/**
 * Collapsed rail: the tile mark alone.
 *
 * Not a cropped-down lockup - the type in the full logo is unreadable at rail
 * width, and the sage tile is a near match for the sidebar's own sage, so the
 * mark keeps its cream plate here too rather than being set straight on the
 * nav.
 */
export const LogoIcon = () => {
  const classes = useStyles();
  return (
    <span className={classes.plate}>
      <img className={classes.mark} src={mark} alt="Aeven OnePlatform" />
    </span>
  );
};
